var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"layout-page"}},[_c('OverdueBookingsWarning'),_c('map-editor',_vm._g({},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }